import type { UUID } from "utils";

const BASE_URL = "/connect";
const ACCOUNT_BASE_URL = `${BASE_URL}/account`;
const PROVIDER_CONFIG_BASE_URL = `${BASE_URL}/provider-config`;

export const PAGE_URLS = {
  accountCreate: `${ACCOUNT_BASE_URL}/create`,
  accountDetails: `${ACCOUNT_BASE_URL}/:accountId`,
  details: BASE_URL,
  notifications: `${BASE_URL}/notifications-settings`,
  payoutNotifications: `${BASE_URL}/payout-notifications-settings`,
  providerConfigList: PROVIDER_CONFIG_BASE_URL,
  providerConfigCreate: `${PROVIDER_CONFIG_BASE_URL}/create/:providerId`,
  providerConfigDetails: `${PROVIDER_CONFIG_BASE_URL}/:configId`,
  providerConfigEdit: `${PROVIDER_CONFIG_BASE_URL}/:configId/edit`,
  getAccountDetails,
  getProviderConfigDetails,
};

function getProviderConfigDetails(configId: UUID) {
  return `${PROVIDER_CONFIG_BASE_URL}/${configId}`;
}

function getAccountDetails(accountId: UUID) {
  return `${ACCOUNT_BASE_URL}/${accountId}`;
}
